<template>
	<footer class="footer">
		<div class="footer__content">
			<div class="footer__content__logo">
				<a href="/"><img :src="logo" alt="Signs Inc." /></a>
			</div>
			<div class="footer__content__social">
				<div class="social">
					<a v-if="linkedin_url" :href="linkedin_url"
						><img :src="linkedin_icon" alt="Follow Signs Inc. on LinkedIn"
					/></a>
					<a v-if="facebook_url" :href="facebook_url"
						><img :src="facebook_icon" alt="Follow Signs Inc. on LinkedIn"
					/></a>
					<a v-if="instagram_url" :href="instagram_url"
						><img :src="instagram_icon" alt="Follow Signs Inc. on LinkedIn"
					/></a>
					<a v-if="mail_url" :href="'mailto:' + mail_url"
						><img :src="mail_icon" alt="Email Signs Inc."
					/></a>
				</div>
				<div class="phone">
					<a
						:href="'tel:' + contact_phone_number"
						v-html="contact_phone_label"
					></a>
				</div>
			</div>
		<div class="footer__content__legal">
			<template v-if="footer_legal_menu && footer_legal_menu.length > 0">
				<a v-for="menu_item in footer_legal_menu" :key="menu_item['title']"
					class="footer__content__legal__child"
					:href="menu_item['url']"
					v-html="menu_item['title']"
				></a>
			</template>
			<span>&copy; Copyright {{ getTheYear }} Signs Inc.</span>
		</div>
			<div class="footer__content__address" v-html="address"></div>
		</div>
		<div class="footer__by_culture_crop">
			<a href="https://culturecrop.co" target="_blank">Site by Culture Crop</a>
		</div>
	</footer>
</template>

<script>
import axios from 'axios';

export default {
	data() {
		return {
			footer_legal_menu: [],
		};
	},

	props: {
		logo: {},
		linkedin_url: {},
		linkedin_icon: {},
		facebook_url: {},
		facebook_icon: {},
		instagram_url: {},
		instagram_icon: {},
		mail_url: {},
		mail_icon: {},
		contact_phone_label: {},
		contact_phone_number: {},
		address: {},
	},

	computed: {
		getTheYear() {
			var d = new Date();
			var n = d.getFullYear();
			return n;
		},
	},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {
		axios
			.get('/wp-json/wp/v2/footer-legal-menu')
			.then(response => (this.footer_legal_menu = response.data));
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.footer {
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	column-gap: 0;
	padding: 50px 0 50px;
	background: $signs-teal;
	row-gap: 100px;

	@media (max-width: 1366px) {
		row-gap: 1.7rem;
	}

	&__content {
		grid-column: 2 / span 10;
		display: grid;
		grid-template-columns: repeat(8, 1fr);
		color: white;
		column-gap: 50px;
		row-gap: 50px;

		@media (max-width: 1366px) {
			grid-template-columns: 1fr;
			grid-template-rows: 1fr;
			grid-column: 2 / span 10;
			row-gap: 25px;
		}

		&__logo {
			grid-column: span 4;
			a {
				img {
					width: 225px;
				}
			}
		}

		&__social {
			grid-column: span 4;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			align-items: flex-end;

			@media (max-width: 1366px) {
				align-items: flex-start;
			}

			.social {
				margin-bottom: 30px;
				display: flex;
				flex-direction: row;

				a {
					color: white;
					display: flex;
					flex-wrap: wrap;
					align-items: flex-start;
					margin-left: 25px;

					@media (max-width: 1366px) {
						margin-left: 0;
						margin-right: 25px;
					}

					img {
						height: 30px;
					}
				}
			}

			.phone {
				a {
					color: white;
					text-decoration: none;
					font-size: 1.5rem;

					img {
						height: 30px;
					}
				}
			}
		}

		&__legal {
			grid-column: span 5;
			text-align: left;
			display: flex;
			flex-direction: row;
			line-height: 1.7rem;

			@media (max-width: 1366px) {
				flex-direction: column;
			}

			&__child {
				position: relative;
				display: flex;

				&::after {
					content: '|';
					margin: 0 20px;

					@media (max-width: 1366px) {
						display: none;
					}
				}
			}

			a {
				text-decoration: none;
				color: white;
			}
		}

		&__address {
			grid-column: span 3;
			text-align: right;

			@media (max-width: 1366px) {
				text-align: left;
			}
		}
	}

	&__by_culture_crop {
		grid-column: 2 / span 10;
		display: grid;
		grid-template-columns: repeat(8, 1fr);
		color: white;
		column-gap: 50px;
		row-gap: 50px;

		@media (max-width: 1366px) {
			grid-template-columns: 1fr;
			grid-template-rows: 1fr;
			grid-column: 2 / span 10;
			row-gap: 25px;
			column-gap: 0;
		}

		a {
			grid-column: 4 / span 2;
			color: #49606e;
			text-decoration: none;
			text-align: center;
			transition: 0.2s ease all;

			@media (max-width: 1366px) {
				grid-column: 1 / span 8;
				text-align: left;
			}

			&:hover {
				color: $signs-pink;
				transition: 0.2s ease all;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteFooter.vue